export default __webpack_public_path__ + "static/media/rotate-solid-arrows.2b73f282.svg";